export const main = '#223268';
export const highlight = '#C72127';
export const shadow = '#22326880';
export const background = '#2232681A';
export const grey = '#989898';
export const black = '#1a1a1a';
export const lightGrey = '#e0e0e0'